import { IconoirCheckCircle } from "@ey-xd/motif-icon";
import "./SuccessMessage.scss";
import { MotifButton, MotifIcon } from "@ey-xd/motif-react";
import { useTranslation } from "react-i18next";
import { CANCEL_BUTTON_VARIANT, SAVE_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { useNavigate } from "react-router-dom";

function SuccessMessage({importJobId,onClose,caseId}:any) {
  const {t}=useTranslation();
  const nav=useNavigate()
  return (
    <div className="success-message">
      <div className="icon-container">
        <MotifIcon
          iconFunction={IconoirCheckCircle}
          stroke="#4CAF50"
          strokeWidth="1"
          size="28" 
        />
      </div>
      <div className="message-title">{t("pages.claims.claimsTable.bulkImport.sucessMessage")}</div>
      <div className="message-description">
      {t("pages.claims.claimsTable.bulkImport.successDescription")}
        </div>
        {importJobId && <div className="motif-row align-self-end mar-t-40 ">
                {onClose && <MotifButton onClick={()=>{
                  if(onClose){
                    onClose()          }
                 }} variant={CANCEL_BUTTON_VARIANT} type="button">{t("global.globalActions.cancel")}</MotifButton>}&nbsp;&nbsp;&nbsp;&nbsp;
                <MotifButton onClick={()=>{
                  if(importJobId){
                    nav(`/case/${caseId}/import/${importJobId}`)
                  }
                 }} variant={SAVE_BUTTON_VARIANT} type="button">{t("pages.claims.claimsTable.bulkImport.viewImportSummary")}</MotifButton>
            
              </div>}
    </div>
  );
}

export default SuccessMessage;
